// El backend manda las horas en ISO con la zona de Chile ("2026-11-19T09:31:00-03:00"): la
// hora local es el texto tal cual, sin pasar por la zona del navegador.
export const hhmm = (iso) => (iso ? iso.slice(11, 16) : "");

export const DIAS = ["", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"];
export const DIAS_CORTOS = ["", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"];

// 19200 -> "5 h 20 min"
export const duracion = (segundos) => {
    const total = Math.round(Math.abs(segundos || 0) / 60);
    const h = Math.floor(total / 60);
    const m = total % 60;
    if (h === 0) return `${m} min`;
    return m === 0 ? `${h} h` : `${h} h ${m} min`;
};

// Con signo, para la diferencia contra el plan. Menos de un minuto cuenta como cero.
export const diferencia = (segundos) => {
    if (Math.abs(segundos || 0) < 60) return "0 min";
    return `${segundos > 0 ? "+" : "−"}${duracion(segundos)}`;
};

// "2026-11-19" -> "19 nov"
const MESES = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];
export const fechaCorta = (iso) => {
    const [, m, d] = iso.split("-").map(Number);
    return `${d} ${MESES[m - 1]}`;
};

export const ESTADOS = {
    completo: { label: "Completo", color: "#15803D", bg: "#DCFCE7" },
    incompleto: { label: "Incompleto", color: "#B45309", bg: "#FEF3C7" },
    ausente: { label: "Ausente", color: "#B91C1C", bg: "#FEE2E2" },
    pendiente: { label: "Pendiente", color: "#4B5563", bg: "#F3F4F6" },
    en_curso: { label: "En curso", color: "#1D4ED8", bg: "#DBEAFE" },
    sin_salida: { label: "Sin salida", color: "#B91C1C", bg: "#FEE2E2" },
    extra: { label: "Fuera de horario", color: "#6D28D9", bg: "#EDE9FE" }
};
